export const beamer = `
  .beamer_beamer.popup {
    top: auto !important;
    left: 76px !important;
    bottom: 52px !important;
  }
`;
